export default __webpack_public_path__ + "static/kv-logo-m-chs-c0379422823f71db1126cd8b50e634a7.png";